<div class="dialog--title"
  cdkDrag cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragFreeDragPosition]="position"
  (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.caseEmployeeInfo.caseEmployeeInfo_employeeInfo | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.caseEmployeeInfo.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <div class="main-container">

    <div class="column-container">
      @if (data.caseDetails.employeeInformation.isAnonymous) {
        <div class="anonymous-info-container">
          <div class="icon-container">
            <p class="body2">{{data.sysText.caseEmployeeInfo.caseEmployeeInfo_confirmInfo  | capitalizefirst}}</p>
            <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
            <button
              type="button"
              class="button-reset info-button"
              [attr.aria-label]="data.sysText.caseEmployeeInfo.moreInformation_ariaLabel"
              [matTooltip]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_anonymousExplanation"
              [matTooltipShowDelay]="500"
              matTooltipPosition="right">
              <mat-icon class="button-icon">info_outline</mat-icon>
            </button>
          </div>
          <p class="body2">
            <strong>{{anonEmployee.fullName}}</strong>
          </p>
          <em>
            @if (anonEmployee.workEmail != null || anonEmployee.workPhone != null) {
              <p class="body2">
                {{anonEmployee.workEmail}}
                @if (anonEmployee.workEmail != null && anonEmployee.workPhone != null) {
                  <span>&bull;</span>
                }
                {{anonEmployee.workPhone}}
              </p>
            }
            @if (anonEmployee.personalEmail != null || anonEmployee.personalPhone != null) {
              <p class="body2">
                {{anonEmployee.personalEmail}}
                @if (anonEmployee.personalEmail != null && anonEmployee.personalPhone != null) {
                  <span>&bull;</span>
                }
                {{anonEmployee.personalPhone}}
              </p>
            }
          </em>
        </div>
      }

      @if (!this.data.canChangeEmployee) {
        <app-input-field
          [group]="form"
          [control]="form.controls.employeeName"
          [icon]="'person'"
          [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_employee"
          [hint]="(data.fieldNotifications.hasOwnProperty('employee') ? data.fieldNotifications['employee'] : null) | capitalizefirst"
          [isHintHighlighted]="false"
          [isHintWarning]="true">
        </app-input-field>
      }

      @if (this.data.canChangeEmployee) {
        <app-autocomplete-field
          [group]="form"
          [control]="employeeField"
          [icon]="'person'"
          [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_employee"
          [options]="data.employeeOptions"
          [interfaceName]="'employee'"
          [isDisabled]="isNewEmployee"
          (hintClick)="onEEHintClick()"
          [hasClickableHint]="true"
          [showSearchIcon]="!(isLoading$ | async)"
          [comboMsError]="true"
          [showSpinner]="(isLoading$ | async)">
        </app-autocomplete-field>
      }

      @if (isNewEmployee) {
        <div class="new-employee">
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_firstName"
                [control]="newEmployee.controls.firstName"
                [hideIconSpace]="true"
                [group]="newEmployee">
              </app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_middleName"
                [control]="newEmployee.controls.middleName"
                [hideIconSpace]="true"
                [group]="newEmployee">
              </app-input-field>
            </div>
          </div>
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_lastName"
                [control]="newEmployee.controls.lastName"
                [hideIconSpace]="true"
                [group]="newEmployee">
              </app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_suffix"
                [control]="newEmployee.controls.suffix"
                [hideIconSpace]="true"
                [group]="newEmployee">
              </app-input-field>
            </div>
          </div>
          <div class="new-ee-full-column">
            <app-input-field
              [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_preferredName"
              [control]="newEmployee.controls.preferredName"
              [group]="newEmployee"
              [hideIconSpace]="true">
            </app-input-field>
          </div>
        </div>
      }

      <app-email-field-group
        [group]="form"
        [workEmailControl]="employeeWorkEmailField"
        [isWorkEmailPreferredControl]="form.controls.workEmailChecked"
        [personalEmailControl]="employeePersonalEmailField"
        [isPersonalEmailPreferredControl]="form.controls.personalEmailChecked">
      </app-email-field-group>

      <app-input-field
        [group]="form"
        [control]="form.controls.workPhone"
        [icon]="'phone'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_workPhone"
        [inputType]="'string'"
        [hint]="(data.fieldNotifications.hasOwnProperty('workPhone') ? data.fieldNotifications['workPhone'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-input-field>

      <app-input-field
        [group]="form"
        [control]="form.controls.personalPhone"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_personalPhone"
        [inputType]="'string'"
        [hint]="(data.fieldNotifications.hasOwnProperty('personalPhone') ? data.fieldNotifications['personalPhone'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-input-field>
    </div>

    <div class="column-container">

      <app-input-field
        [group]="form"
        [control]="form.controls.company"
        [icon]="'business'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_company"
        [hint]="(data.fieldNotifications.hasOwnProperty('company') ? data.fieldNotifications['company'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true">
      </app-input-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.workLocation"
        [icon]="'location_on'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_workLocation"
        [options]="data.workLocations"
        [isSimple]="true"
        [hint]="(data.fieldNotifications.hasOwnProperty('workLocation') ? data.fieldNotifications['workLocation'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-autocomplete-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.jobTitle"
        [icon]="'work'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_jobTitle"
        [options]="data.jobTitles"
        [isSimple]="true"
        [hint]="(data.fieldNotifications.hasOwnProperty('jobTitle') ? data.fieldNotifications['jobTitle'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-autocomplete-field>

      <app-input-field
        [group]="form"
        [control]="form.controls.city"
        [icon]="'location_city'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_city"
        [hint]="(data.fieldNotifications.hasOwnProperty('city') ? data.fieldNotifications['city'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-input-field>

      <div class="select-container">
        <mat-icon [ngClass]="{ focus: select.focused }">map</mat-icon>
        <mat-form-field color="accent">
          <mat-label>{{ data.sysText.caseEmployeeInfo.caseEmployeeInfo_state | titlecase }}</mat-label>
          <mat-select #select="matSelect" [formControl]="form.controls.stateId" [value]="data.caseDetails.employeeInformation.stateId" disableOptionCentering panelClass="dropDownSelect" panelWidth="fit-content">
            <mat-option [value]="null"></mat-option>
            @for (state of data.stateOptions; track state) {
              <mat-option [value]=state.id>
                <span>{{ state.description }}</span>
              </mat-option>
            }
          </mat-select>
          <mat-hint>
            @if (data.fieldNotifications.hasOwnProperty('stateId')) {
              <p class="mat-hint-combined warn">
                {{ data.fieldNotifications['stateId'] }}
              </p>
            }
          </mat-hint>
          <mat-error>{{ form.controls.stateId.errors?.msError }}</mat-error>
          @if (form.controls.stateId.errors?.required) {
            <mat-error>{{ data.sysText.caseEmployeeInfo.required }}</mat-error>
          }
        </mat-form-field>
        <button
          type="button"
          class="button-reset info-button"
          [attr.aria-label]="data.sysText.caseEmployeeInfo.moreInformation_ariaLabel"
          [matTooltip]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_stateInfo"
          [matTooltipShowDelay]="500"
          matTooltipPosition="above">
          <mat-icon class="button-icon">info_outline</mat-icon>
        </button>
      </div>

      <div class="contact-group">
        @for (sv of supervisorsArray.controls; track sv; let i = $index) {
          <div class="group-form-container">
            <div class="contact-container">
              <div class="input-auto-field" [ngClass]="{'w-90': (supervisorsArray.controls.length > 1)}">
                <app-autocomplete-field
                  [group]="sv"
                  [control]="sv.controls.employeeId"
                  [icon]="i > 0 ? '' : 'person'"
                  [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor"
                  [options]="data.supervisorOptions"
                  [interfaceName]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor"
                  [isDisabled]="isNewSupervisor[i]"
                  (hintClick)="onAddSupervisorContact(i)"
                  [hasClickableHint]="true"
                  [showSearchIcon]="true"
                  [comboMsError]="true">
                </app-autocomplete-field>
              </div>
              @if (supervisorsArray.controls.length > 1) {
                <button
                  mat-icon-button
                  [attr.aria-label]="data.sysText.caseEmployeeInfo.remove_ariaLabel"
                  [disableRipple]="true"
                  (click)="onRemoveSupervisorContact(i)"
                  >
                  <mat-icon [ngClass]="{'accent': true, 'margin-bottom-17': !(isMobile$ | async)}">close</mat-icon>
                </button>
              }
            </div>
            @if (isNewSupervisor[i]) {
              <div class="new-employee">
                <div class="sub-employee">
                  <div class="new-ee-column">
                    <app-input-field
                      [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_firstName"
                      [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_firstName"
                      [control]="sv.controls.firstName"
                      [hideIconSpace]="true"
                      [group]="sv">
                    </app-input-field>
                  </div>
                  <div class="new-ee-column left-margin">
                    <app-input-field
                      [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_middleName"
                      [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_middleName"
                      [control]="sv.controls.middleName"
                      [hideIconSpace]="true"
                      [group]="sv">
                    </app-input-field>
                  </div>
                </div>
                <div class="sub-employee">
                  <div class="new-ee-column">
                    <app-input-field
                      [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_lastName"
                      [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_lastName"
                      [control]="sv.controls.lastName"
                      [hideIconSpace]="true"
                      [group]="sv">
                    </app-input-field>
                  </div>
                  <div class="new-ee-column left-margin">
                    <app-input-field
                      [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_suffix"
                      [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_suffix"
                      [control]="sv.controls.suffix"
                      [hideIconSpace]="true"
                      [group]="sv">
                    </app-input-field>
                  </div>
                </div>
                <div class="new-ee-full-column">
                  <app-input-field
                    [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_preferredName"
                    [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_preferredName"
                    [control]="sv.controls.preferredName"
                    [group]="sv"
                    [hideIconSpace]="true">
                  </app-input-field>
                </div>
                <app-email-field-group
                  [ariaLabelPrefix]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor"
                  [group]="form"
                  [hideIconSpace]="true"
                  [workEmailControl]="sv.controls.workEmail"
                  [isWorkEmailPreferredControl]="sv.controls.workEmailChecked"
                  [personalEmailControl]="sv.controls.personalEmail"
                  [isPersonalEmailPreferredControl]="sv.controls.personalEmailChecked">
                </app-email-field-group>
                <div class="sub-employee">
                  <div class="new-ee-column">
                    <app-input-field
                      [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_workPhone"
                      [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_workPhone"
                      [control]="sv.controls.workPhone"
                      [hideIconSpace]="true"
                      [group]="sv">
                    </app-input-field>
                  </div>
                  <div class="new-ee-column left-margin">
                    <app-input-field
                      [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_personalPhone"
                      [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_supervisor + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_personalPhone"
                      [control]="sv.controls.personalPhone"
                      [hideIconSpace]="true"
                      [group]="sv">
                    </app-input-field>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <button
          #addSupervisorButton
          (click)="addSupervisorFormGroup()"
          mat-flat-button
          color="accent"
          class="button add-additional-button">
          {{data.sysText.caseEmployeeInfo.addAdditionalSupervisor}}
        </button>
      </div>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.hrManagerId"
        [icon]="'supervisor_account'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager"
        [options]="data.hrManagerOptions"
        [interfaceName]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager"
        [isDisabled]="isNewHrManager || (isLoading$ | async)"
        (hintClick)="onHrManagerHintClick()"
        [hasClickableHint]="true"
        [showSearchIcon]="true"
        [showHintAndError]="true"
        [shouldCasePipe]="false">
      </app-autocomplete-field>

      @if (isNewHrManager) {
        <div class="new-employee">
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_firstName"
                [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_firstName"
                [control]="newEmployeeHrManager.controls.firstName"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager">
              </app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_middleName"
                [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_middleName"
                [control]="newEmployeeHrManager.controls.middleName"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager">
              </app-input-field>
            </div>
          </div>
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_lastName"
                [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_lastName"
                [control]="newEmployeeHrManager.controls.lastName"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager">
              </app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_suffix"
                [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_suffix"
                [control]="newEmployeeHrManager.controls.suffix"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager">
              </app-input-field>
            </div>
          </div>
          <div class="new-ee-full-column">
            <div>
              <app-input-field
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_preferredName"
                [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_preferredName"
                [control]="newEmployeeHrManager.controls.preferredName"
                [group]="newEmployeeHrManager"
                [hideIconSpace]="true">
              </app-input-field>
            </div>
          </div>
          <app-email-field-group
            [ariaLabelPrefix]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager"
            [group]="form"
            [hideIconSpace]="true"
            [workEmailControl]="newEmployeeHrManager.controls.workEmail"
            [isWorkEmailPreferredControl]="newEmployeeHrManager.controls.workEmailChecked"
            [personalEmailControl]="newEmployeeHrManager.controls.personalEmail"
            [isPersonalEmailPreferredControl]="newEmployeeHrManager.controls.personalEmailChecked">
          </app-email-field-group>
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [group]="newEmployeeHrManager"
                [control]="newEmployeeHrManager.controls.workPhone"
                [hideIconSpace]="true"
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_workPhone"
                [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_workPhone"
                [inputType]="'string'">
              </app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [group]="newEmployeeHrManager"
                [control]="newEmployeeHrManager.controls.personalPhone"
                [hideIconSpace]="true"
                [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_personalPhone"
                [ariaLabel]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hrManager + ' ' + data.sysText.caseEmployeeInfo.caseEmployeeInfo_personalPhone"
                [inputType]="'string'">
              </app-input-field>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="main-container">
    <div class="column-container">
      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.employmentStatus"
        [icon]="'badge'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_employmentStatus"
        [options]="data.employmentStatuses"
        [isSimple]="true"
        [hint]="(data.fieldNotifications.hasOwnProperty('employmentStatus') ? data.fieldNotifications['employmentStatus'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-autocomplete-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.employeeType"
        [icon]="'badge'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_employeeType"
        [options]="data.employeeTypes"
        [isSimple]="true"
        [hint]="(data.fieldNotifications.hasOwnProperty('employeeType') ? data.fieldNotifications['employeeType'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-autocomplete-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.payType"
        [icon]="'badge'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_payType"
        [options]="data.payTypes"
        [isSimple]="true"
        [hint]="(data.fieldNotifications.hasOwnProperty('payType') ? data.fieldNotifications['payType'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-autocomplete-field>

      <app-date-field
        [group]="form"
        [control]="form.controls.hireDate"
        [icon]="'today'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_hireDate"
        [hint]="(data.fieldNotifications.hasOwnProperty('hireDate') ? data.fieldNotifications['hireDate'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-date-field>

      <app-date-field
        [group]="form"
        [control]="form.controls.originalHireDate"
        [icon]="'today'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_originalHireDate"
        [hint]="(data.fieldNotifications.hasOwnProperty('originalHireDate') ? data.fieldNotifications['originalHireDate'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-date-field>

      <app-date-field
        [group]="form"
        [control]="form.controls.lastTerminationDate"
        [icon]="'today'"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_lastTerminationDate"
        [hint]="(data.fieldNotifications.hasOwnProperty('lastTerminationDate') ? data.fieldNotifications['lastTerminationDate'] : null) | capitalizefirst"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
        [isDisabled]="(isLoading$ | async)">
      </app-date-field>
    </div>

    <div class="column-container">
      <app-text-area
        [group]="form"
        [control]="form.controls.fixedLeaveYearStart"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_fixedLeaveYearStart"
        [info]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_fixedLeaveYearStart_info"
        [icon]="'today'">
      </app-text-area>

      @if (data.caseDetails.employeeInformation.showBank1FirstLeaveUsage) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank1FirstLeaveUsageDate"
          [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank1FirstLeaveUsageDate | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [info]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank1FirstLeaveUsageDate_info | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [icon]="'today'"
          [dontCapitalizeFirst]=true>
        </app-date-field>
      }

      @if (data.caseDetails.employeeInformation.showBank2FirstLeaveUsage) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank2FirstLeaveUsageDate"
          [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank2FirstLeaveUsageDate | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [info]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank2FirstLeaveUsageDate_info | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [icon]="'today'"
          [dontCapitalizeFirst]=true>
        </app-date-field>
      }

      @if (data.caseDetails.employeeInformation.showBank3FirstLeaveUsage) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank3FirstLeaveUsageDate"
          [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank3FirstLeaveUsageDate | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [info]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank3FirstLeaveUsageDate_info | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [icon]="'today'"
          [dontCapitalizeFirst]=true>
        </app-date-field>
      }

      @if (data.caseDetails.employeeInformation.showBank4FirstLeaveUsage) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank4FirstLeaveUsageDate"
          [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank4FirstLeaveUsageDate | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [info]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank4FirstLeaveUsageDate_info | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [icon]="'today'"
          [dontCapitalizeFirst]=true>
        </app-date-field>
      }

      @if (data.caseDetails.employeeInformation.showBank5FirstLeaveUsage) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank5FirstLeaveUsageDate"
          [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank5FirstLeaveUsageDate | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [info]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_bank5FirstLeaveUsageDate_info | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets"
          [icon]="'today'"
          [dontCapitalizeFirst]=true>
        </app-date-field>
      }
    </div>
  </div>

  @if (form.controls.userDefinedFields.controls.length > 0) {
    <div class="main-container">
      <div class="column-container">
        @for(userDefinedFieldGroup of positionUserDefinedFields(form.controls.userDefinedFields, userDefinedFieldPosition.employeeInfoLeft, true); track userDefinedFieldGroup) {
          <app-user-defined-field
            [form]="form"
            [userDefinedFieldGroup]="userDefinedFieldGroup">
          </app-user-defined-field>
        }
      </div>
      <div class="column-container">
        @for(userDefinedFieldGroup of positionUserDefinedFields(form.controls.userDefinedFields, userDefinedFieldPosition.employeeInfoRight); track userDefinedFieldGroup) {
          <app-user-defined-field
            [form]="form"
            [userDefinedFieldGroup]="userDefinedFieldGroup">
          </app-user-defined-field>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ $safeNavigationMigration(this.form.errors?.msError) | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets}}</mat-error>
  }
  @if ((showNotifyToggle$ | async)) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="(isSubmitting$ | async)"
        [label]="data.sysText.caseEmployeeInfo.caseEmployeeInfo_sendNotification">
      </app-slide-toggle>
    </div>
  }

  @let isSubmitting = isSubmitting$ | async;
  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close(false)">
        {{ data.sysText.caseEmployeeInfo.cancel }}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.caseEmployeeInfo.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit(false)">
      {{ data.sysText.caseEmployeeInfo.save }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>
